export const navigation = ({
    main: {
        changePassword: {
            index: '/app/changePassword',
        },
        passwordChanged: {
            index: '/app/passwordChanged',
        },
        forbidden: {
            index: '/app/forbidden',
        },
        reports: {
            index: '/app/reports',
        },
        srsCodes: {
            index: '/app/srsCodes',

            /** @param {String} product */
            srsCodeDetails: (product) => `/app/srsCodes/${product}`,
        },
        users: {
            index: `/app/users`,

            /** @param {Number} userId */
            details: (userId) => `/app/users/${userId}`,
            new: `/app/users/new`,
        },
    },
})
